/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MacroRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getMacros
 */
export const GET_MACROS_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getMacros';
export const GET_MACROS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MACROS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getMacrosRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getMacrosPaginated
 */
export const GET_MACROS_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getMacrosPaginated';
export const GET_MACROS_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MACROS_PAGINATED_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getMacrosPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getMacro
 */
export const GET_MACRO_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getMacro';
export const GET_MACRO_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MACRO_QUERY_FIELD_NAME,
  args: ['macroId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['name', 'description', 'workflowId', 'workflowCrmId', 'templateId', 'shortcut', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#updateMacro
 */
export const UPDATE_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_updateMacro';
export const UPDATE_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId', 'name', 'description', 'workflowId', 'workflowCrmId', 'templateId', 'shortcut', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#deleteMacro
 */
export const DELETE_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_deleteMacro';
export const DELETE_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.deleteMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#hardDeleteMacro
 */
export const HARD_DELETE_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_hardDeleteMacro';
export const HARD_DELETE_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: HARD_DELETE_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.hardDeleteMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#runMacro
 */
export const RUN_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_runMacro';
export const RUN_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RUN_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId', 'objectId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.runMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getWorkflowsPaginated
 */
export const GET_WORKFLOWS_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getWorkflowsPaginated';
export const GET_WORKFLOWS_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_WORKFLOWS_PAGINATED_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getWorkflowsPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getWorkflowMetadata
 */
export const GET_WORKFLOW_METADATA_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getWorkflowMetadata';
export const GET_WORKFLOW_METADATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_WORKFLOW_METADATA_QUERY_FIELD_NAME,
  args: ['workflowId', 'workflowCrmId'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getWorkflowMetadataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});